import {addAuthToAxiosOpts} from '../config/queryopts'
import {useQueryWithAuthentication} from "./index";
import {apiUrlInternal} from "../config/api"
import axios from "axios";


export const KeywordTypesFetcher = (accessToken) => {
  return axios.get(`${apiUrlInternal}/keywords/types`, addAuthToAxiosOpts(accessToken, {})).then(res => res.data);
}

export const useKeywordTypesQuery = (fetcher = KeywordTypesFetcher) => {
  return useQueryWithAuthentication(
    ['keyword-types'], (accessToken) => fetcher(accessToken), {staleTime: Infinity}
  )
}
